<template>
  <div>
    <CRow class="top-content">
      <CCol sm="12">
        <CCard>
          <CCardHeader
            class="w-100 d-flex justify-content-between align-items-center"
          >
            <TimeCard isManager />
          </CCardHeader>
          <CCardBody class="d-flex align-items-center text-center h-100">
            <CDataTable
              class="w-100 d-flex justify-content-between h-100"
              :noItemsView="{
                noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
              }"
              :items="computedCalendar"
              :fields="calendarFields"
              hover
              striped
              border
              small
              fixed
              :loading="loading"
            >
              <template #edit="{ item }">
                <td>
                  <CButton square size="sm" @click="onEditCalendarModal(item)">
                    <CIcon name="cil-pen" />
                  </CButton>
                </td>
              </template>
            </CDataTable>
            <EditCalendarModal
              v-model="editCalendarModal"
              :calendar="selectedItem"
              @get-calendar="getCalendar"
            />
          </CCardBody>
          <CCardFooter
            class="d-flex justify-content-center justify-content-sm-end"
          >
            <CButton
              color="primary"
              :disabled="loading"
              square
              size="md"
              class="px-5 ml-4"
              @click="getBeforeCalendar"
            >
              قبلی
            </CButton>
            <CButton
              color="primary"
              :disabled="loading"
              square
              size="md"
              class="px-5"
              @click="getNextCalendar"
            >
              بعدی
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader
            class="w-100 d-flex justify-content-between align-items-center"
          >
            کلاس‌های در حال برگزاری
          </CCardHeader>
          <CCardBody class="d-flex align-items-center text-center h-100">
            <CDataTable
              class="w-100 d-flex justify-content-between h-100"
              :noItemsView="{
                noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
              }"
              :items="computedActiveCourses"
              :fields="activeKlassFields"
              hover
              striped
              border
              small
              fixed
            >
              <template #activeKlassEnter="{ item }">
                <td>
                  <CButton
                    :disabled="loading"
                    square
                    size="sm"
                    class="modal-button"
                  >
                    <a :href="item.link" target="_blank">ورود</a>
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import EditCalendarModal from "@/components/Modals/Calendar/EditCalendarModal.vue";
import TimeCard from "@/components/TimeCard/TimeCard.vue";
export default {
  components: { EditCalendarModal, TimeCard },
  name: "ManagerDashboard",
  data() {
    return {
      calendarFields: [
        { key: "dayName", label: "روز" },
        { key: "computedDate", label: "تاریخ" },
        { key: "text", label: "توضیحات" },
        { key: "edit", label: "ویرایش" },
      ],
      activeKlassFields: [
        { key: "activeKlassGrade", label: "پایه" },
        { key: "activeKlassKlass", label: "کلاس" },
        { key: "activeKlassCourse", label: "نام درس" },
        { key: "activeKlassTeacher", label: "معلم" },
        { key: "activeKlassTime", label: "زمان" },
        { key: "activeKlassEnter", label: "ورود به کلاس" },
      ],
      loading: false,
      activeCourses: [],
      calendar: [],
      nextId: 0,
      beforeId: 0,
      editCalendarModal: false,
      selectedItem: {},
    };
  },
  computed: {
    computedCalendar() {
      return this.calendar.map((item) => {
        return {
          ...item,
          computedDate: item.date.replaceAll("-", "/"),
        };
      });
    },
    computedActiveCourses() {
      return this.activeCourses.map((item) => {
        return {
          ...item,
          activeKlassGrade: `${item.course.klass.grade.name}`,
          activeKlassKlass: `${item.course.klass.name}`,
          activeKlassCourse: `${item.course.name}`,
          activeKlassTime: `${item.endTime} - ${item.startTime}`,
          activeKlassTeacher: `${item.course.teacher.name} ${item.course.teacher.lastname}`,
        };
      });
    },
  },
  mounted() {
    this.getActiveCourse();
    this.getCalendar();
  },
  methods: {
    async getActiveCourse() {
      try {
        this.loading = true;
        const { data } = await axios.get("/course/active");
        this.activeCourses = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getCalendar() {
      try {
        this.loading = true;
        const payload = {
          nextId: this.nextId,
          beforeId: this.beforeId,
        };
        const { data } = await axios.get("/calendar", {
          params: { ...payload },
        });
        this.calendar = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    getBeforeCalendar() {
      this.nextId = 0;
      this.beforeId = this.calendar[0].id--;

      this.getCalendar();
    },
    getNextCalendar() {
      this.beforeId = 0;
      this.nextId = this.calendar[6].id++;
      this.getCalendar();
    },
    onEditCalendarModal(item) {
      this.selectedItem = item;
      this.editCalendarModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  th {
    font-size: 16px;
  }
  td {
    font-size: 14px;
  }
}
a {
  color: inherit;
}
</style>
